import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createBlock(_component_el_checkbox_group, {
    modelValue: _ctx.teethStone,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teethStone) = $event)),
    class: "teeth-stone",
    onChange: _ctx.controlCheckboxesState
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teethStoneOptions, (option) => {
        return (_openBlock(), _createBlock(_component_el_checkbox, {
          key: option.id,
          disabled: !option.enable,
          label: option.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.value), 1)
          ]),
          _: 2
        }, 1032, ["disabled", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "onChange"]))
}